'use client';
import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { StyledGetInTouch } from '@/components/common/ygen/sections/get-in-touch/get-in-touch.style';
import { Col, Container, Row } from 'react-bootstrap';
import Title from '@/components/common/ui/text/Title';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import LinkOnly from '@/components/common/ui/buttons/LinkOnly';
import Quote from '@/components/common/ygen/sections/quote/Quote';
import Modal from 'react-bootstrap/Modal';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
const GetInTouch = ({ data, color }) => {
	const offset = useContainerOffset('.container');
	const [modalIsOpen, setModalIsOpen] = useState(false);

	// Memoize computed styles
	const containerStyle = useMemo(() => ({
		paddingLeft: offset + 15 + 'px',
		paddingRight: offset + 15 + 'px'
	}), [offset]);

	const sectionStyle = useMemo(() => ({
		marginRight: offset + 15 + 'px'
	}), [offset]);

	// Memoize event handlers
	const handleModalOpen = useCallback((e) => {
		e.preventDefault();
		window.history.pushState(null, '', '#get-in-quote');
		setModalIsOpen(true);
	}, []);

	const handleModalClose = useCallback(() => {
		setModalIsOpen(false);
		window.location.hash = '';
	}, []);

	// Handle body overflow and hash-based modal opening
	useEffect(() => {
		if (modalIsOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'auto';
		}

		if (window.location.hash === '#get-in-touch') {
			setModalIsOpen(true);
		}

		return () => {
			document.body.style.overflow = 'auto';
		};
	}, [modalIsOpen]);
	useEffect(() => {
		const container = document.querySelector('.word-rotator-words');
		if (!container) return;

		const words = container.querySelectorAll('b');
		let index = Array.from(words).findIndex(w => w.classList.contains('is-visible'));
		if (index === -1) index = 0;

		const updateContainerWidth = () => {
			const currentWord = words[index];
			gsap.set(container, { width: currentWord.offsetWidth });
		};

		updateContainerWidth();

		const rotateWords = () => {
			const current = words[index];
			const nextIndex = (index + 1) % words.length;
			const next = words[nextIndex];

			const nextWidth = next.offsetWidth;

			gsap.to(current, {
				duration: 1,
				onComplete: () => {
					current.classList.remove('is-visible');
					current.classList.add('is-hidden');

					next.classList.remove('is-hidden');
					next.classList.add('is-visible');


					gsap.to(container, {
						width: nextWidth,
						duration: 1,
						ease: 'power2.out',
					});

					index = nextIndex;
				}
			});
		};
		ScrollTrigger.refresh();
		const interval = setInterval(rotateWords, 2000);
		return () => clearInterval(interval);
	}, []);
	return (
		<>
			<StyledGetInTouch  color={color} className="map">
				<div className="wrapper-box" style={sectionStyle}>
					<Container fluid style={containerStyle}>
						<Row>
							<Col md={7}>
								<Title
									tag="h2"
									margin="0"
									width="100%"
									text="We are YGEN, we <i><span class='word-rotator-words '>
												<b class='is-hidden'>build</b>
												<b class='is-hidden'>create</b>
												<b class='is-visible'>develop</b>
											</span></i>  <i>solutions</i>."
									color="#fff"
								/>
								<p>Share your inquiries for prompt responses!</p>
							</Col>
							<Col md={5} className="d-flex align-items-center justify-content-end">
								<div className="get_in_touch" onClick={handleModalOpen}>
									<LinkOnly src="/contact" text="Get in Touch" icon />
								</div>
							</Col>


						</Row>
					</Container>
				</div>
			</StyledGetInTouch>

			<Modal
				className="modal-video"
				show={modalIsOpen}
				onHide={handleModalClose}
			>
				<Modal.Body className="video">
					<Quote data="contact_form" onclick={handleModalClose} />
				</Modal.Body>
			</Modal>
		</>
	);
};


export default React.memo(GetInTouch);
